/* eslint-disable better-mutation/no-mutation */
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { Charity } from 'tradera/state/services/types/webapi-selling-generated';

type CharityCampaignSlice = Partial<Charity> & {
    isSchenkerPaidBySchenker: boolean;
};

const initialState: CharityCampaignSlice = {
    charityId: undefined,
    forceFreeShipping: false,
    name: null,
    description: null,
    isSchenkerPaidBySchenker: false
};

function isSchenkerPaying(campaignCode: string) {
    const code = campaignCode.toUpperCase();
    return (
        code == 'MHO20' ||
        code == 'MHF20' ||
        code == 'MH20' ||
        code == 'MHTEST' ||
        code == 'MHTESTF'
    );
}

const charityCampaignSlice = createSlice({
    name: 'charityCampaign',
    initialState,
    reducers: {
        resetCharityCampaign: () => initialState,
        setCharityCampaign: (
            state,
            action: PayloadAction<{
                charityCampaign: Charity;
                campaignCode: string;
            }>
        ) => {
            const { charityCampaign, campaignCode } = action.payload;
            state.charityId = charityCampaign.charityId;
            state.forceFreeShipping = charityCampaign.forceFreeShipping;
            state.name = charityCampaign.name ?? null;
            state.description = charityCampaign.description ?? null;
            state.isSchenkerPaidBySchenker = isSchenkerPaying(campaignCode);
            state.allowZeroDayAuctions = charityCampaign.allowZeroDayAuctions;
        }
    }
});

export const { resetCharityCampaign, setCharityCampaign } =
    charityCampaignSlice.actions;
export default charityCampaignSlice.reducer;
